import { render, staticRenderFns } from "./UserGroupNew.vue?vue&type=template&id=986a7aee&"
import script from "./UserGroupNew.vue?vue&type=script&lang=js&"
export * from "./UserGroupNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports